
      import API from "!../../../speedyg/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
      import domAPI from "!../../../speedyg/node_modules/style-loader/dist/runtime/styleDomAPI.js";
      import insertFn from "!../../../speedyg/node_modules/style-loader/dist/runtime/insertBySelector.js";
      import setAttributes from "!../../../speedyg/node_modules/style-loader/dist/runtime/setAttributesWithoutAttributes.js";
      import insertStyleElement from "!../../../speedyg/node_modules/style-loader/dist/runtime/insertStyleElement.js";
      import styleTagTransformFn from "!../../../speedyg/node_modules/style-loader/dist/runtime/styleTagTransform.js";
      import content, * as namedExport from "!!../../../speedyg/node_modules/css-loader/dist/cjs.js!./fallbackFonts.css";
      
      

var options = {};

options.styleTagTransform = styleTagTransformFn;
options.setAttributes = setAttributes;
options.insert = insertFn.bind(null, "head");
options.domAPI = domAPI;
options.insertStyleElement = insertStyleElement;

var update = API(content, options);



export * from "!!../../../speedyg/node_modules/css-loader/dist/cjs.js!./fallbackFonts.css";
       export default content && content.locals ? content.locals : undefined;
